import { Box, Flex, Text, Tooltip, useBreakpointValue } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const HeaderOption = ({ o, style }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const iconSize = useBreakpointValue({ base: "14px", sm: "15px", md: "20px" });
  const padding = useBreakpointValue({
    base: "8px 12px",
    sm: "10px 20px",
    md: "12px 32px",
  });

  const activeLink = location.pathname === o.link;

  return (
    <Tooltip label={o.title} hidden={isMobile} fontSize="x-small">
      <Flex
        onClick={() => navigate(o.link)}
        backgroundColor={activeLink ? "var(--main-bg-color)" : "white"}
        borderBottomWidth={"1px"}
        borderBottomColor="lightgray"
        borderRightWidth={activeLink ? "3px" : undefined}
        borderRightColor={activeLink ? "var(--icon-color)" : undefined}
        _hover={{
          backgroundColor: activeLink
            ? "var(--main-bg-color)"
            : "var(--hover-color)",
        }}
        cursor="pointer"
        padding={padding}
        style={{ ...style }}
        alignItems="center"
        gap="8px"
        fontWeight="semibold"
        flexShrink={0}
        overflow="hidden"
        whiteSpace={{ base: "nowrap", md: "normal" }}
        textOverflow="ellipsis"
      >
        <Box
          fontWeight="semibold"
          color="var(--icon-color)"
          fontSize={iconSize}
          className="material-symbols-outlined"
        >
          {o.icon}
        </Box>
        <Text
          color={activeLink ? "var(--icon-color)" : undefined}
          textAlign="center"
          // fontSize={fontSize}
          letterSpacing="0px"
          isTruncated
          size="sm"
        >
          {o.title}
        </Text>
      </Flex>
    </Tooltip>
  );
};

export default HeaderOption;
